var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8583 9.37728L11.1074 11.4552V7.29932L14.8583 9.37728Z",
    fill: "#484848",
    stroke: "#484848",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.112V8.6417C2 5.63348 2 4.12939 2.9704 3.1616C3.9408 2.19382 5.46856 2.15193 8.52405 2.06815C9.97194 2.02845 11.4509 2 12.7168 2C13.9827 2 15.4617 2.02845 16.9095 2.06815C19.965 2.15193 21.4928 2.19382 22.4632 3.1616C23.4336 4.12939 23.4336 5.63348 23.4336 8.6417V10.112C23.4336 13.1201 23.4336 14.6243 22.4632 15.592C21.4928 16.5598 19.9651 16.6017 16.9096 16.6855C15.4617 16.7252 13.9827 16.7537 12.7168 16.7537C11.4509 16.7537 9.97187 16.7252 8.52396 16.6855C5.4685 16.6017 3.94078 16.5598 2.97038 15.592C2 14.6243 2 13.1201 2 10.112Z",
    stroke: "#484848",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon _youtube_.e4896415c74db8e13d9e74786d320b99.svg";
export { ForwardRef as ReactComponent };